import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/user";

class UserService {
  getAdminUserInfo = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/me`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching admin user info.");
    }
  };
}
const userService = new UserService();

export default userService;
